import { render, staticRenderFns } from "./StackListItem.vue?vue&type=template&id=4db07ac0"
import script from "./StackListItem.vue?vue&type=script&lang=js"
export * from "./StackListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports